import { assert } from '@varos/util-typescript';
import { ContributorShellControllerBaseConfig } from '../../../base';
import {
    ContributorShellContext,
    ContributorShellContextController,
} from './contributorContextInterface';

export function createContributorContextController(
    config: ContributorShellControllerBaseConfig
): ContributorShellContextController {
    return {
        useProps(item, props) {
            const auth = config.hook.useAuth();
            assert(auth.user?.id, 'missing user id');
            assert(auth.scheme.kind === 'legacy', 'only legacy auth is supported');
            const value: ContributorShellContext = item.asset
                ? {
                      kind: 'workspace',
                      principal: {
                          kind: 'user',
                          id: auth.user.id,
                          account: 'acct_adasasdas',
                      },
                      organization: null,
                      asset: item.asset,
                      auth,
                      //   TODO fix
                      token: 'NOT SET',
                  }
                : {
                      kind: 'organization',
                      principal: {
                          kind: 'user',
                          id: auth.user.id,
                          account: 'acct_adasasdas',
                      },
                      organization: null,
                      auth,
                      //   TODO fix
                      token: 'NOT SET',
                  };
            return {
                provider: {
                    value,
                },
            };
        },
    };
}
